export default function Main({ children }) {

	return (
		<main className="mx-auto max-w-7xl px-4 lg:px-0 text-[#8a8f98]">
			{children}
		</main>
	)
}
